import styled from '@emotion/styled';

export const StickyButton = styled.button`
  position: fixed;
  left: 96.5vw;
  bottom: 2vh;
  border-radius: 36px;
  padding: 9px 7px 6px;
  background-color: black;
`;

const TableInfiniteScrollStyles = styled.div`
  overflow-x: auto;
  .table-infinite-scroll {
    display: inline-block;
    min-width: ${({ fullWidth, scrollbarSize }) =>
      `${fullWidth ? `calc(100% - ${scrollbarSize}px) !important` : 'auto'}`};
    width: fit-content;
    border: ${({ designTokens }) => `1px solid ${designTokens.podiumCdsColorBorderSecondary}`};
    background: ${({ designTokens }) => `${designTokens.podiumCdsColorTextPrimaryInverse}`};
    .th {
      background: ${({ designTokens }) => `${designTokens.podiumCdsColorGrey200}`};
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: ${({ designTokens }) => `1px solid ${designTokens.podiumCdsColorBorderSecondary}`};
    }

    .td {
      background: ${({ designTokens }) => `${designTokens.podiumCdsColorTextPrimaryInverse}`};
      border-top: ${({ designTokens }) => `1px solid ${designTokens.podiumCdsColorBorderSecondary}`};
    }
    .th,
    .td {
      margin: 0;
      padding: 10px;
      border-right: ${({ designTokens }) => `1px solid ${designTokens.podiumCdsColorBorderSecondary}`};
    }
    .tr:first-of-type {
      .td {
        border-top: 0;
      }
    }

    .tr {
      .td:last-child,
      .th:last-child {
        border-right: 0;
      }
    }
  }
`;

export default TableInfiniteScrollStyles;
